import { PerformanceTier, TierKeys } from '../types/performanceTier';

export type HostMetricsSettings = {
  // In Time Response Events
  POINTS_FOR_IN_TIME_RESPONSE: number;
  POINTS_FOR_NOT_IN_TIME_RESPONSE: number;
  IN_TIME_RESPONSE_MAX_SCORE: number;
  IN_TIME_RESPONSE_MIN_SCORE: number;
  IN_TIME_RESPONSE_LIMIT_HOURS: number;

  // Review Events
  POSITIVE_REVIEW: number;
  NEGATIVE_REVIEW: number;
  REVIEW_MAX_SCORE: number;
  REVIEW_MIN_SCORE: number;

  // Level Thresholds
  LEVEL_1_THRESHOLD: number;
  LEVEL_2_THRESHOLD: number;
  LEVEL_3_THRESHOLD: number;
};

export type ScoringEventType = 'IN_TIME_RESPONSE_EVENT' | 'REVIEW_EVENT';

export type ScoringEvent = {
  id: string;
  type: ScoringEventType;
  points: number;
  conversationId: string | null;
  hostScoreId: string;
  accountId: string;
  createdAt: Date;
  updatedAt: Date;
};

export type HostScore = {
  id: string;
  type: ScoringEventType;
  accountId: string;
  cappedScore: number;
  totalScore: number;
  createdAt: Date;
  updatedAt: Date;
  level: number;
};

export const getHostMetricsLevelLabelAndIcon = (level: number) => {
  const levelKey = TierKeys[level];
  switch (levelKey) {
    case 'basic':
      return { label: PerformanceTier[levelKey], icon: '' };
    case 'bronze':
      return { label: PerformanceTier[levelKey], icon: '🥉' };
    case 'silver':
      return { label: PerformanceTier[levelKey], icon: '🥈' };
    case 'gold':
      return { label: PerformanceTier[levelKey], icon: '🥇' };
    default:
      console.error(`Unknown score level: ${level}`);
      return { label: level, icon: undefined };
  }
};

export const getHostScoringTypeLabel = (type: ScoringEventType) => {
  switch (type) {
    case 'IN_TIME_RESPONSE_EVENT':
      return 'Timely Response';
    case 'REVIEW_EVENT':
      return 'Review';
    default:
      console.error(`Unknown ScoringEventType: ${type}`);
      return type;
  }
};

export const getPercentageWithinTier = (
  score: number,
  tier: number,
  type: ScoringEventType,
  settings: HostMetricsSettings,
) => {
  const {
    LEVEL_1_THRESHOLD,
    LEVEL_2_THRESHOLD,
    LEVEL_3_THRESHOLD,
    IN_TIME_RESPONSE_MAX_SCORE,
    REVIEW_MAX_SCORE,
  } = settings;

  const MAX_SCORE =
    type === 'IN_TIME_RESPONSE_EVENT'
      ? IN_TIME_RESPONSE_MAX_SCORE
      : REVIEW_MAX_SCORE;

  switch (tier) {
    case 0:
      return (score / LEVEL_1_THRESHOLD) * 100;
    case 1:
      return (
        ((score - LEVEL_1_THRESHOLD) /
          (LEVEL_2_THRESHOLD - LEVEL_1_THRESHOLD)) *
        100
      );
    case 2:
      return (
        ((score - LEVEL_2_THRESHOLD) /
          (LEVEL_3_THRESHOLD - LEVEL_2_THRESHOLD)) *
        100
      );
    case 3:
      return (
        ((score - LEVEL_3_THRESHOLD) / (MAX_SCORE - LEVEL_3_THRESHOLD)) * 100
      );
    default:
      console.error(`Unknown tier: ${tier}`);
      return 0;
  }
};
